














// vue
import { computed, defineComponent, ref, watch, onBeforeMount } from '@vue/composition-api';

// primevue
import Checkbox from 'primevue/checkbox';

export default defineComponent({
    props: {
        value: {
            type: Object,
            default: () => {},
        },
        data: {
            type: Array,
            default: () => [],
        },
        options: {
            type: Object,
            default: () => {},
        },
    },
    components: {
        Checkbox,
    },
    setup(props: any, { emit }) {
        const localValue = ref<any>({ ...props.value });

        watch(localValue, (newValue:any) => {
            const emittingValue = {...props.value, value: [], displayValue: []};
            emittingValue['value'] = newValue.value;
            emittingValue['displayValue'] = newValue.value.map((id:any)=> {
                for(const item of props.data){
                    const itemValue = item[props.options.optionValue];
                    if(itemValue == id){
                        return item[props.options.optionLabel];
                    }
                }
                return ""
            })
            emit('input', emittingValue);
        }, { deep: true });

        const checkboxStyle = computed(() => {
            if (props.options.optionLabel === 'hole') {
                return 'flex w-14 space-x-2 m-2';
            } else {
                return 'flex space-x-2';
            }
        });

        const checkboxContainerStyle = computed(() => {
            if (props.options.optionLabel === 'hole') {
                return 'flex flex-wrap';
            } else {
                return 'space-y-2';
            }
        });

        const onLoad = () => {
            emit('input', {...props.value, operator: 'in', displayValue: []})
        }

        onBeforeMount(()=>{
            onLoad();
        })

        return {
            localValue,
            checkboxStyle,
            checkboxContainerStyle,
        };
    },
});
